import React, { useState, useEffect } from 'react';
import { getWelcome } from '@/lib/api';
import { Info, Loader2 } from 'lucide-react';

export default function WelcomePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWelcome().then(setData).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-[#3A4035] animate-spin" /></div>;

  return (
    <div className="animate-fade-in" data-testid="welcome-page">
      <div className="mb-8">
        <h1 className="font-heading text-2xl sm:text-3xl font-medium text-[#1A1A1A] tracking-tight">{data?.title || 'Welcome'}</h1>
        <p className="text-sm text-[#5C5C55] mt-1">Everything you need to get started</p>
      </div>

      <div className="space-y-4">
        {(data?.sections || []).map((section, i) => (
          <div key={section.heading} className={`bg-white rounded-2xl border border-[#E5E2DC] shadow-[0_2px_10px_rgba(0,0,0,0.02)] p-6 animate-fade-in stagger-${i + 1}`}>
            <h2 className="font-heading text-base font-medium text-[#1A1A1A] mb-2">{section.heading}</h2>
            <p className="text-sm text-[#5C5C55] leading-relaxed">{section.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
